enum TiposPessoa {
    Fisica = 0,
    Juridica = 1,
    ProdutorRural = 2,
}

export default TiposPessoa;
